module.exports = __webpack_public_path__ + "img/quasar.8c53bfb5.jpg";